seo<template>
    <div class="mainBox">
        <div class="m_title">SEO配置</div>
        <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick">
            <el-tab-pane label="中文" name="1">
                <el-form ref="updateForm" :model="updateForm" :rules='formItemRules' label-width="80px" size="medium">
                    <el-form-item prop='title' label='标题'>
                        <el-input v-model="updateForm.title" placeholder='请输入标题' clearable></el-input>
                    </el-form-item>
                    <el-form-item prop='keyword' label='关键字'>
                        <el-input type="textarea" :autosize="{ minRows: 2}" v-model="updateForm.keyword"></el-input>
                    </el-form-item>
                    <el-form-item prop='description' label='描述'>
                        <el-input type="textarea" :autosize="{ minRows: 4}" v-model="updateForm.description"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="medium" type="primary" @click="onSubmitForm">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="英语" name="2">
                <el-form ref="updateForm" :model="updateForm" :rules='formItemRules' label-width="80px" size="medium">
                    <el-form-item prop='title' label='标题'>
                        <el-input v-model="updateForm.title" placeholder='请输入标题' clearable></el-input>
                    </el-form-item>
                    <el-form-item prop='keyword' label='关键字'>
                        <el-input type="textarea" :autosize="{ minRows: 2}" v-model="updateForm.keyword"></el-input>
                    </el-form-item>
                    <el-form-item prop='description' label='描述'>
                        <el-input type="textarea" :autosize="{ minRows: 4}" v-model="updateForm.description"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="medium" type="primary" @click="onSubmitForm">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {seoDetail,seoUpdate} from '@/utils/getData';

    export default {
        name: "seoEdit",
        data(){
            return{
                activeName:'1',
                updateForm: {
                    title: "",
                    keyword: "",
                    description:""
                },
                formItemRules: {
                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }],
                    keyword: [{
                        required: true,
                        message: '请输入关键字',
                        trigger: 'blur'
                    }],
                    description: [{
                        required: true,
                        message: '请输入描述',
                        trigger: 'blur'
                    }]
                },
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(){
                try {
                    let res = await seoDetail(this.activeName);
                    if (res.code == 0) {
                        this.updateForm = res.data;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                } catch(e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            handleClick(tab) {
                this.activeName = tab.name;
                this.init();
            },
            onSubmitForm() { //提交表单
                let that = this;
                this.$refs['updateForm'].validate(async (valid) => {
                    try{
                        if (valid) {
                            let formData = that.updateForm;
                            const res = await seoUpdate(that.updateForm.id, formData);
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '保存成功',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        }
                    }catch (e) {
                        this.$message({
                            showClose:true,
                            message: e.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .m_title{border-bottom:2px solid #999;line-height:40px;margin-bottom:30px;padding-left:15px;position:relative;}
	.m_title:before{position: absolute;left:0;top:20%;width:3px;height:60%;background:#1876EF;content: "";}
</style>